module.exports = global["Player"] = require("-!/mnt/jenkins/var-lib-jenkins/jobs/animoto_player_deploy/workspace/node_modules/babel-loader/index.js!/mnt/jenkins/var-lib-jenkins/jobs/animoto_player_deploy/workspace/src/player.js");


/*****************
 ** WEBPACK FOOTER
 ** ./src/player.js
 ** module id = 0
 ** module chunks = 0
 **/